import { Tags } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function ConfigurationFieldDate(props: {
	field: graphql.ConnectorConfigFieldDate;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => void;
}) {
	return (
		<Tags.Item.DatePicker
			value={props.change?.date ?? props.field.date}
			onChange={(date) => props.onChange({ date })}
		/>
	);
}
